import { Injectable } from '@angular/core';
import { LookUpMasterModel } from './shared/models/lookup-master/lookup-master.model';
import { LookUpResourceModel } from './section-wise/models/lookup-resource.model';
import { UrlConfigModel } from './shared/models/start-up-config/initial-config.model';
import { AbTestConfigModel } from './shared/models/start-up-config/abtest-config-model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationConstant {
  public static isOwnLandingRedirected: boolean;
  public static isOwnLanding: boolean;
  public static lookMasterDetails: Array<LookUpMasterModel>;
  public static lookupResourceDetails: Array<LookUpResourceModel>;
  public static urlConfig: UrlConfigModel;
  public static abTestConfig: AbTestConfigModel;
}
